export const translations = {
  pt: {
    nav_services: 'Serviços',
    nav_portfolio: 'Portfólio',
    nav_about: 'Sobre',
    nav_contact: 'Contacto',
    nav_cta: 'Pedir Orçamento',

    hero_eyebrow: 'Lisboa & Distrito de Setúbal',
    hero_headline: 'Montagem profissional e remodelações com qualidade garantida',
    hero_subheadline: 'Cozinhas, mobiliário, pisos e obras nos distritos de Lisboa e Setúbal',
    hero_cta_primary: 'Pedir Orçamento',
    hero_cta_secondary: 'Ver Portfólio',
    hero_trust_1: '+5',
    hero_trust_1_sub: 'Anos de Experiência',
    hero_trust_2: '+200',
    hero_trust_2_sub: 'Obras Concluídas',
    hero_trust_3: '100%',
    hero_trust_3_sub: 'Satisfação',

    services_label: 'O Que Fazemos',
    services_title: 'Serviços Profissionais',
    services_subtitle: 'Instalação, montagem e remodelação com qualidade e rigor em cada detalhe.',
    service_1_title: 'Montagem de Cozinhas',
    service_1_desc: 'Cozinhas pré-fabricadas IKEA, Leroy Merlin e outras. Instalação completa com nivelamento e ligações.',
    service_2_title: 'Montagem de Mobiliário',
    service_2_desc: 'Roupeiros, estantes, cómodas e todo o tipo de mobiliário com precisão e cuidado.',
    service_3_title: 'Piso Flutuante',
    service_3_desc: 'Instalação profissional de piso flutuante com acabamento impecável e nivelamento perfeito.',
    service_4_title: 'Porcelanato / Azulejo',
    service_4_desc: 'Colocação de cerâmica, porcelanato e azulejo para pavimentos e revestimentos.',
    service_5_title: 'Serviços de Pedreiro',
    service_5_desc: 'Obras de alvenaria, abertura e selagem de paredes, reparações gerais de construção.',
    service_6_title: 'Remodelações',
    service_6_desc: 'Renovações interiores completas — da conceção à conclusão, com qualidade e prazo garantidos.',

    portfolio_label: 'O Nosso Trabalho',
    portfolio_title: 'Portfólio',
    portfolio_subtitle: 'Veja alguns dos nossos trabalhos mais recentes em Lisboa e Setúbal.',
    filter_all: 'Todos',
    filter_kitchens: 'Cozinhas',
    filter_floors: 'Pisos',
    filter_furniture: 'Mobiliário',
    filter_masonry: 'Pedreiro',
    filter_renovations: 'Remodelações',

    about_label: 'Sobre Nós',
    about_title: 'Compromisso com a excelência em cada obra',
    about_p1: 'A RJ Montagens e Remodelações é uma empresa especializada em serviços de montagem, instalação e remodelação, com mais de 5 anos de experiência nos distritos de Lisboa e Setúbal.',
    about_p2: 'O nosso compromisso é garantir um trabalho de qualidade superior, entregue dentro do prazo e com total transparência. Cada projeto é tratado com máximo rigor e atenção ao detalhe.',
    about_stat_1: '+5',
    about_stat_1_label: 'Anos de Experiência',
    about_stat_2: '+200',
    about_stat_2_label: 'Obras Concluídas',
    about_stat_3: '2',
    about_stat_3_label: 'Distritos Servidos',
    about_stat_4: '100%',
    about_stat_4_label: 'Satisfação Garantida',

    testimonials_label: 'Testemunhos',
    testimonials_title: 'O que dizem os nossos clientes',

    contact_label: 'Contacto',
    contact_title: 'Peça o seu orçamento',
    contact_subtitle: 'Preencha o formulário e entraremos em contacto brevemente.',
    form_name: 'Nome completo',
    form_email: 'Email',
    form_phone: 'Telefone',
    form_service: 'Serviço pretendido',
    form_service_placeholder: 'Selecione um serviço',
    form_message: 'Mensagem / Descrição do trabalho',
    form_submit: 'Pedir Orçamento',
    form_submitting: 'A enviar...',
    form_success: 'Pedido enviado com sucesso! Entraremos em contacto brevemente.',
    form_error: 'Erro ao enviar o pedido. Por favor tente novamente.',
    contact_info_title: 'Informações de Contacto',
    contact_email_label: 'Email',
    contact_areas: 'Áreas de Serviço',
    contact_areas_value: 'Distrito de Lisboa e Distrito de Setúbal',
    contact_hours: 'Horário',
    contact_hours_value: 'Segunda a Sexta: 8h – 18h',
    contact_hours_value2: 'Sábado: 8h – 13h',
    contact_phone_label: 'Telefone',
    contact_phone: '+351 915 995 141',

    footer_tagline: 'Montagem e remodelação profissional nos distritos de Lisboa e Setúbal.',
    footer_services_title: 'Serviços',
    footer_contact_title: 'Contacto',
    footer_rights: 'Todos os direitos reservados.',

    service_options: [
      'Montagem de Cozinhas',
      'Montagem de Mobiliário',
      'Piso Flutuante',
      'Porcelanato / Azulejo',
      'Serviços de Pedreiro',
      'Remodelações',
      'Outro',
    ],
    footer_services_list: [
      'Montagem de Cozinhas',
      'Montagem de Mobiliário',
      'Piso Flutuante',
      'Porcelanato / Azulejo',
      'Serviços de Pedreiro',
      'Remodelações',
    ],
  },

  es: {
    nav_services: 'Servicios',
    nav_portfolio: 'Portafolio',
    nav_about: 'Sobre',
    nav_contact: 'Contacto',
    nav_cta: 'Pedir Presupuesto',

    hero_eyebrow: 'Lisboa & Distrito de Setúbal',
    hero_headline: 'Montaje profesional y reformas con calidad garantizada',
    hero_subheadline: 'Cocinas, mobiliario, suelos y obras en los distritos de Lisboa y Setúbal',
    hero_cta_primary: 'Pedir Presupuesto',
    hero_cta_secondary: 'Ver Portafolio',
    hero_trust_1: '+5',
    hero_trust_1_sub: 'Años de Experiencia',
    hero_trust_2: '+200',
    hero_trust_2_sub: 'Obras Terminadas',
    hero_trust_3: '100%',
    hero_trust_3_sub: 'Satisfacción',

    services_label: 'Lo Que Hacemos',
    services_title: 'Servicios Profesionales',
    services_subtitle: 'Instalación, montaje y reforma con calidad y rigor en cada detalle.',
    service_1_title: 'Montaje de Cocinas',
    service_1_desc: 'Cocinas prefabricadas IKEA, Leroy Merlin y otras. Instalación completa con nivelación y conexiones.',
    service_2_title: 'Montaje de Mobiliario',
    service_2_desc: 'Armarios, estanterías, cómodas y todo tipo de muebles con precisión y cuidado.',
    service_3_title: 'Suelo Flotante',
    service_3_desc: 'Instalación profesional de suelo flotante con acabado impecable y nivelación perfecta.',
    service_4_title: 'Porcelanato / Azulejo',
    service_4_desc: 'Colocación de cerámica, porcelanato y azulejo para pavimentos y revestimientos.',
    service_5_title: 'Servicios de Albañilería',
    service_5_desc: 'Obras de albañilería, apertura y sellado de paredes, reparaciones generales de construcción.',
    service_6_title: 'Reformas',
    service_6_desc: 'Renovaciones interiores completas — desde la concepción hasta la conclusión, con calidad y plazo garantizados.',

    portfolio_label: 'Nuestro Trabajo',
    portfolio_title: 'Portafolio',
    portfolio_subtitle: 'Vea algunos de nuestros trabajos más recientes en Lisboa y Setúbal.',
    filter_all: 'Todos',
    filter_kitchens: 'Cocinas',
    filter_floors: 'Suelos',
    filter_furniture: 'Mobiliario',
    filter_masonry: 'Albañilería',
    filter_renovations: 'Reformas',

    about_label: 'Sobre Nosotros',
    about_title: 'Compromiso con la excelencia en cada obra',
    about_p1: 'RJ Montagens e Remodelações es una empresa especializada en servicios de montaje, instalación y reforma, con más de 5 años de experiencia en los distritos de Lisboa y Setúbal.',
    about_p2: 'Nuestro compromiso es garantizar un trabajo de calidad superior, entregado dentro del plazo y con total transparencia. Cada proyecto se trata con máximo rigor y atención al detalle.',
    about_stat_1: '+5',
    about_stat_1_label: 'Años de Experiencia',
    about_stat_2: '+200',
    about_stat_2_label: 'Obras Terminadas',
    about_stat_3: '2',
    about_stat_3_label: 'Distritos Servidos',
    about_stat_4: '100%',
    about_stat_4_label: 'Satisfacción Garantizada',

    testimonials_label: 'Testimonios',
    testimonials_title: 'Lo que dicen nuestros clientes',

    contact_label: 'Contacto',
    contact_title: 'Pida su presupuesto',
    contact_subtitle: 'Rellene el formulario y nos pondremos en contacto en breve.',
    form_name: 'Nombre completo',
    form_email: 'Email',
    form_phone: 'Teléfono',
    form_service: 'Servicio deseado',
    form_service_placeholder: 'Seleccione un servicio',
    form_message: 'Mensaje / Descripción del trabajo',
    form_submit: 'Pedir Presupuesto',
    form_submitting: 'Enviando...',
    form_success: '¡Solicitud enviada con éxito! Nos pondremos en contacto en breve.',
    form_error: 'Error al enviar la solicitud. Por favor inténtelo de nuevo.',
    contact_info_title: 'Información de Contacto',
    contact_email_label: 'Email',
    contact_areas: 'Áreas de Servicio',
    contact_areas_value: 'Distrito de Lisboa y Distrito de Setúbal',
    contact_hours: 'Horario',
    contact_hours_value: 'Lunes a Viernes: 8h – 18h',
    contact_hours_value2: 'Sábado: 8h – 13h',
    contact_phone_label: 'Teléfono',
    contact_phone: '+351 915 995 141',

    footer_tagline: 'Montaje y reforma profesional en los distritos de Lisboa y Setúbal.',
    footer_services_title: 'Servicios',
    footer_contact_title: 'Contacto',
    footer_rights: 'Todos los derechos reservados.',

    service_options: [
      'Montaje de Cocinas',
      'Montaje de Mobiliario',
      'Suelo Flotante',
      'Porcelanato / Azulejo',
      'Servicios de Albañilería',
      'Reformas',
      'Otro',
    ],
    footer_services_list: [
      'Montaje de Cocinas',
      'Montaje de Mobiliario',
      'Suelo Flotante',
      'Porcelanato / Azulejo',
      'Servicios de Albañilería',
      'Reformas',
    ],
  },
};
